/**
 * Dependencies.
 */
import { setupI18n } from '@prz-dp/services';
import { UI_I18N_MESSAGES } from '@prz-dp/ui';

import I18N_BASE from '@/modules/base/i18n';
import { I18N_CAMPAIGNS_MODULE } from '@/modules/campaigns/campaigns.module';
import { I18N_CHALLENGES_MODULE } from '@/modules/challenges/challenges.module';
import { I18N_CHAT_MODULE } from '@/modules/chat/chat.module';
import { I18N_COMMUNICATIONS_MODULE } from '@/modules/communications/communications.module';
import { I18N_COUNTERPARTS_MODULE } from '@/modules/counterparts/counterparts.module';
import { I18N_DASHBOARD_MODULE } from '@/modules/dashboard/dashboard.module';
import { I18N_DETAILS_MODULE } from '@/modules/details/details.module';
import { I18N_EXTERNAL_MODULE } from '@/modules/external/external.module';
import { I18N_LINKS_MODULE } from '@/modules/links/links.module';
import { I18N_MAIN } from '@/modules/main/main.module';
import { I18N_PARTNERS_MODULE } from '@/modules/members/members.module';
import { I18N_MENTIONS_MODULE } from '@/modules/mentions/mentions.module';
import { I18N_ORDERS_MODULE } from '@/modules/orders/orders.module';
import { I18N_PRODUCTS_OFFERED_MODULE } from '@/modules/products-offered/products-offered.module';
import { I18N_PRODUCTS_MODULE } from '@/modules/products/products.module';
import { I18N_REMUNERATIONS_MODULE } from '@/modules/remunerations/remunerations.module';
import { I18N_SN_MODULE } from '@/modules/social-network/social-network.module';

export type I18nMessagesType = typeof I18N_MAIN &
  typeof I18N_BASE &
  typeof I18N_CHALLENGES_MODULE &
  typeof I18N_COUNTERPARTS_MODULE &
  typeof I18N_DASHBOARD_MODULE &
  typeof I18N_DETAILS_MODULE &
  typeof I18N_EXTERNAL_MODULE &
  typeof I18N_ORDERS_MODULE &
  typeof I18N_MENTIONS_MODULE &
  typeof I18N_PRODUCTS_MODULE &
  typeof I18N_REMUNERATIONS_MODULE &
  typeof UI_I18N_MESSAGES &
  typeof I18N_CAMPAIGNS_MODULE &
  typeof I18N_PARTNERS_MODULE &
  typeof I18N_COMMUNICATIONS_MODULE &
  typeof I18N_CHAT_MODULE &
  typeof I18N_PRODUCTS_OFFERED_MODULE &
  typeof I18N_LINKS_MODULE &
  typeof I18N_SN_MODULE;

/**
 * Export.
 */
export const i18n = setupI18n([
  I18N_MAIN,
  I18N_BASE,
  I18N_CHALLENGES_MODULE,
  I18N_COUNTERPARTS_MODULE,
  I18N_DASHBOARD_MODULE,
  I18N_DETAILS_MODULE,
  I18N_EXTERNAL_MODULE,
  I18N_ORDERS_MODULE,
  I18N_MENTIONS_MODULE,
  I18N_PRODUCTS_MODULE,
  I18N_REMUNERATIONS_MODULE,
  UI_I18N_MESSAGES,
  I18N_CAMPAIGNS_MODULE,
  I18N_PARTNERS_MODULE,
  I18N_COMMUNICATIONS_MODULE,
  I18N_CHAT_MODULE,
  I18N_PRODUCTS_OFFERED_MODULE,
  I18N_LINKS_MODULE,
  I18N_SN_MODULE
]);
